import { useEffect, useState } from 'react'
import Select from 'react-select';

//STYLES && ICONS
import './AdminBarTasks.css'
import SaveIcon from "../../../../assets/icons/save.svg";
import DeleteIcon from "../../../../assets/icons/delete.svg";
import UpIcon from "../../../../assets/icons/up.svg";
import DownIcon from "../../../../assets/icons/down.svg";
import CloseIcon from "../../../../assets/icons/close.svg";

const HTML_TAG_OPTIONS = Object.freeze({
  DIV: {value: 'div', label:'Div'},
  TITLE: {value: 'h2', label:'Titre'},
  SUBTITLE: {value: 'h3', label:'Sous-titre'},
  PARAGRAPH: {value: 'p', label:'Paragraph'},
})


export default function TaskEditor({
  task, 
  cat, 
  open = false, 
  newTask = false, 
  saveTask,
  deleteTask,
  moveTask,
  order: newOrder
}) {
    const [title, setTitle] = useState('')
    const [contentBlocks, setContentBlocks] = useState([])
    const [newBlockTag, setNewBlockTag] = useState('')
    const [newBlockContent, setNewBlockContent] = useState('')
    const [currentCat, setCurrentCat] = useState('null')
    const [currentOrder, setCurrentOrder] = useState(null)
    const [tabIsOpen, setTabIsOpen] = useState(open)
    const [showAddNewblock, setShowAddNewBlock] = useState(false)
    const [isMoving, setIsMoving] = useState(false)

    const defaultHtmlTag = HTML_TAG_OPTIONS.PARAGRAPH

    useEffect(() => {
      setNewBlockTag(defaultHtmlTag)
      if (task) {
            setTitle(task.title)
            if (task.contentBlocks) {
                setContentBlocks(task.contentBlocks)
            }
            setCurrentCat(task.catId)
            setCurrentOrder(task.order)
        }
        if (cat) {
          setCurrentCat(cat)
        }
        if (newOrder) {
          setCurrentOrder(newOrder)
        }
    }, [task, cat, newOrder])
  
    // Setting up the options for the Select
    let options = []
    const tagLists =Object.keys(HTML_TAG_OPTIONS)
    tagLists.map( tag => options.push(HTML_TAG_OPTIONS[tag]))



    const getTagLabel = (tag) => {
      const o = options.filter(t => t.value == tag)[0]
      console.log('tag is ', tag, ' therefore option is ', o)
      return o.label
    }
  
    const handleNewBlock = (e) => {
      e.preventDefault()
      let order = contentBlocks.length + 1
      const blockToAdd = {tag: newBlockTag.value, content: newBlockContent, order }
      setContentBlocks( (prev) => [...prev, blockToAdd])
      setNewBlockTag('')
      setNewBlockContent('')
      handleToggleShowNewBlock()
    }
  
    const resetNewTask = () => {
      setTitle('')
      setContentBlocks([])
      setNewBlockTag('')
      setNewBlockContent('')

    }
    const handleSubmit = (e) => {
      e.preventDefault()
      saveTask(getModifiedTask(newOrder))
      if (!newTask) {
        setTabIsOpen(false)
      } else {
        resetNewTask()
      }
    }

    const handleMove = (direction) => {
      setIsMoving(true)
      moveTask(task, direction)
      setTimeout(() => {
        setIsMoving(false)
      }, 600);
    }
    
    const getModifiedTask = () => {
      const tasktoAdd = {
        id: task ? task.id : Math.random(),
        title,
        contentBlocks,
        catId: currentCat,
        order: currentOrder,
        modified: task ? task.modified : false,
        newTask: task ? task.newTask : false,
      }
      console.log(tasktoAdd)
      return tasktoAdd
    }
    
    const handleDelete = (e) => {
      e.preventDefault()
      deleteTask(task.id)
    }
  
    const handleToggleTab = (e) => {
      e.preventDefault()
      if (tabIsOpen) {
        //we are going to close the tab, I then persist the changes in local task
        saveTask(getModifiedTask(task.order))
      }
      setTabIsOpen(prev => !prev)
    }

    const handleToggleShowNewBlock = () => {
      setShowAddNewBlock(prev => !prev)
    }
  
    const handleItemChange = (index, newValue, prop) => {
      setContentBlocks( (prev) => {
        const newBlocks = []
        console.log(prev, index)
        prev.map( (i, _index) => {
            console.log('index : ', index, ' - _index : ', _index)
          if (index === _index) {
            console.log('sameIndex')
            switch (prop) {
                case 'tag':
                  newBlocks[index] = {...i, tag:newValue.value}
                  break;
                case 'content':
                  newBlocks[index] = {...i, content:newValue}
                  break;
                default:
                    break;
            }
          } else {
            console.log('different Index')
            newBlocks[_index] = {...i}
          }
        })
        return newBlocks
      })
    }
  
    const handleItemDelete = (index) => {
      setContentBlocks( (prev) => {
        const newBlocks = []
        prev.map( (i, _index) => {
          if (_index != index) {
            newBlocks.push({...i})
          }
        })
        return newBlocks
      })
    }

    return (
        <div className="task-container">
            {!newTask && (<div className={`task ${task.newTask ? 'added' : ''} ${task.modified && !task.newTask ? 'updated' : ''}`}>
                <p className="task-title">{title}</p>
                <div className="task-btns">
                    <button className="btn" onClick={handleToggleTab}>Edit</button>
                    <div className='btn edit-btn'>
                      <img src={DeleteIcon} alt="delete-icon" onClick={handleDelete} />
                    </div>
                    {!isMoving && (
                    <>
                    <div className='btn edit-btn'>
                      <img src={UpIcon} alt="up-icon" onClick={() => handleMove('up')} />
                    </div>
                    <div className='btn edit-btn'>
                      <img src={DownIcon} alt="down-icon" onClick={() => handleMove('down')} />
                    </div>
                    </>
                    )}
                    {isMoving && (
                    <div className='btn edit-btn'>
                      <span>...</span>
                    </div>
                    )}
                    {/* 
                    TO DO
                    <button className="btn">Add before</button>
                    <button className="btn">Add After</button> */}
                </div>
            </div>)}
            { tabIsOpen && (
            <form className='task-form indented' onSubmit={(e) => handleSubmit(e, 1)}>
            <label>
                <span>Titre :</span>
                <input 
                type="text"
                onChange={(e) => setTitle(e.target.value)}
                value={title}
                required
                />
            </label>
            <div className="blocks-list">
                { contentBlocks && contentBlocks.map( (item, index) => (
                <div key={item.order} className='block-item'>
                <label>
                    <span>Html tag:</span>
                    <Select 
                        options={options}
                        onChange={(option) => handleItemChange(index, option, 'tag')}
                        value = {{label: getTagLabel(item.tag), value: item.tag}}
                    />
                </label>
                <label>
                    <span>Content :</span>
                    <textarea 
                    name="" id="" cols="30" rows="10"
                    onChange={(e) => handleItemChange(index, e.target.value, 'content')}
                    value={item.content}
                    required
                    />
                </label>
                <button className='btn' onClick={() => handleItemDelete(index)}>delete</button>
                </div>
                ))}
                <div className="block-item" onClick={handleToggleShowNewBlock}>
                Add new block :
                </div>
                {showAddNewblock && (<div className='block-item'>
                    <label>
                    <span>Html tag:</span>
                    <Select 
                        options={options}
                        onChange={(option) => setNewBlockTag(option)}
                        defaultValue={HTML_TAG_OPTIONS.PARAGRAPH}
                    />
                    </label>
                    <label>
                    <span>Content :</span>
                    <textarea 
                        name="" id="" cols="30" rows="10"
                        onChange={(e) => setNewBlockContent(e.target.value)}
                        value={newBlockContent}
                    />
                    </label>
                    {(!newBlockTag || !newBlockContent) && <button 
                        className="btn block-btn" 
                        disabled>+</button>}
                    {newBlockTag && newBlockContent && <button 
                        className="btn block-btn" 
                        onClick={(e) => handleNewBlock(e) }>+</button>}
                </div>)}

            </div>
            <div className='side-btns'>
                {!newTask && (
                  <button className='btn edit-btn'>
                    <img src={CloseIcon} alt="close-icon" onClick={handleToggleTab} />
                  </button>
                )}

                {(newTask && <button type="submit" className='btn edit-btn'>
                  <img src={SaveIcon} alt="save-icon" />
                </button>)}
            </div>
            </form>
            )}
        </div>
    )
}
